/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Sc_NoteInputs */

const en_tut_sc_note = /** @type {(inputs: Tut_Sc_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Single-letter shortcuts stop working while you are typing in a text field, so they never get in the way of writing. \`⌘⏎\` and \`Esc\` apply inside each composer and dialog rather than as one global binding.`)
};

const id_tut_sc_note = /** @type {(inputs: Tut_Sc_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pintasan huruf tunggal berhenti bekerja selama Anda mengetik di kolom teks, jadi ia tidak pernah mengganggu penulisan. \`⌘⏎\` dan \`Esc\` berlaku di masing-masing kolom tulis dan dialog, bukan satu pintasan global.`)
};

/**
* | output |
* | --- |
* | "Single-letter shortcuts stop working while you are typing in a text field, so they never get in the way of writing. `⌘⏎` and `Esc` apply inside each composer..." |
*
* @param {Tut_Sc_NoteInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_sc_note = /** @type {((inputs?: Tut_Sc_NoteInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Sc_NoteInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_sc_note(inputs)
	return en_tut_sc_note(inputs)
});